// React imports.
import React from "react";

import { Assessment1StepsEnum } from "../state";
import { Assessment1FuelStatusEnum } from "../state";


const Assessment1QuestionsOverReporting = ({fuelType, state, showDontKnowNote }) => (
    <div>
        <ol>
            <li>
                One or more of the vendors are including optional charges (e.g. deposits or service contracts)
                in the expenditure amounts they report to you. If that occurred,  you will need to ask the
                vendor to supply the expenditure amounts for their LIHEAP households without any optional
                charges included.
                <br/><br/>
            </li>
            <li>
                One or more of the vendors reported data for a period greater than 12 months. If that
                occurred, you would need to ask them to report information for a 12-month period only.
                <br/><br/>
            </li>
            <li>
                One or more of the vendors have included outliers caused by errors in the data they
                report to you. For example, sometimes when a household owns a farm, the vendor reports
                the farm account rather than the household account. If errors like this occurred,
                you will need to have your IT department identify the outliers and contact the vendor
                to confirm the true expenditure amounts for the households in question.
                <br/><br/>
            </li>
            <li>
                One or more of your vendors reported the total amount owed (including arrearages) by
                each household each month rather than the amount that each household was billed. If
                this occurred, you will need to ask the vendor to supply expenditure amounts that
                include only the new amount that each household was billed each month without the
                inclusion of any arrearages or other overdue charges.
                <br/><br/>
            </li>
            <li>
                One or more of your vendors may be including third-party supplier charges that
                are much higher than regular utility charges. If this is the case your average
                electric expenditures would be higher than expected but would still be reliable
                because you are supposed to include third-party charges in the amounts that you report.
                <br/><br/>
            </li>
        </ol>

        Let's walk through each of these issues so that you can assess whether any of them might be a problem for your data.&nbsp;
        {showDontKnowNote === true
          &&<span>
                Please answer each of the questions below. Depending on your response, each question
                may ask you to outline an action item to help you address the issue.
                <br/><br/>
                <strong>
                    If you don't know the answer to a question please indicate "Don't Know"
                    and provide your plans to acquire this information from IT department or
                    programming staff in the response box.
                </strong>
            </span>}
        <br/><br/>

        <ol>
            {/*OPTIONAL*/}
            <li>
                Do your electric vendors indicate they are excluding optional charges
                (e.g. deposits, servicing contracts, repair charges, and purchase charges)
                in the expenditure amounts they report to you?
                <br/>
                <label>
                    <input type="radio"
                        name="IncludingEnergyOptionalChargesFlag"
                        id="IncludingEnergyOptionalChargesFlag_false"
                        value="N"
                        checked={fuelType.IncludingEnergyOptionalChargesFlag === "N"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludingEnergyOptionalChargesFlag"
                        id="IncludingEnergyOptionalChargesFlag_true"
                        value="Y"
                        checked={fuelType.IncludingEnergyOptionalChargesFlag === "Y"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludingEnergyOptionalChargesFlag"
                        id="IncludingEnergyOptionalChargesFlag_dk"
                        value="U"
                        checked={fuelType.IncludingEnergyOptionalChargesFlag === "U"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Don't Know</span>
                </label>
                <br/ >
                {fuelType.IncludingEnergyOptionalChargesFlag === "N"
                  && <span>
                      <strong>No action needed.</strong>  
                      Your electric vendors should be excluding optional charges from
                      the expenditure amounts they report to you.
                    </span>
                  }
                {fuelType.IncludingEnergyOptionalChargesFlag === "Y"
                  &&
                    <span>
                      <strong>Requires followup.</strong>&nbsp;
                      Your electric vendors should be excluding optional charges from the
                      expenditure amounts they report to you. If your vendors are not
                      excluding optional charges this will cause your reported average
                      electric baseload expenditures to be too high.
                      <br/><br/>
                      Please indicate your plans to address this issue in the box below
                      <textarea  name="IncludingEnergyOptionalChargesDesc"
                          id="IncludingEnergyOptionalChargesDesc" style={{width:"100%"}}
                          value={fuelType.IncludingEnergyOptionalChargesDesc}
                          onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                {fuelType.IncludingEnergyOptionalChargesFlag === "U"
                  &&
                    <span>
                      <strong>Requires followup.</strong>&nbsp;
                      You need to know whether or not your electric vendors are excluding optional
                      charges from the expenditure amounts they report to you in order to perform
                      a complete assessment of your data. You may need to review your vendor
                      agreements or discuss with your IT department to obtain this information. 
                      <br/><br/>
                      Please indicate your plans for obtaining this information in the box below.
                      <textarea  name="IncludingEnergyOptionalChargesDesc"
                          id="IncludingEnergyOptionalChargesDesc" style={{width:"100%"}}
                          value={fuelType.IncludingEnergyOptionalChargesDesc}
                          onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {/*12 MONTH ONLY*/}
            <li>
                Can you confirm that all of your electric vendors are reporting for a 12-month period
                and are not reporting for a period longer than 12 months?
                <br/>
                <label>
                    <input type="radio"
                        name="Including12MonthOnlyFlag"
                        id="Including12MonthOnlyFlag_true"
                        value="Y"
                        checked={fuelType.Including12MonthOnlyFlag === "Y"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="Including12MonthOnlyFlag"
                        id="Including12MonthOnlyFlag_false"
                        value="N"
                        checked={fuelType.Including12MonthOnlyFlag === "N"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="Including12MonthOnlyFlag"
                        id="Including12MonthOnlyFlag_dk"
                        value="U"
                        checked={fuelType.Including12MonthOnlyFlag === "U"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Don't Know</span>
                </label>
                <br/ >
                {fuelType.Including12MonthOnlyFlag === "Y"
                  && <span>
                        <strong>No action needed.</strong>
                        Your electric vendors should only be reporting electric billing data for
                        a 12-month period.  
                    </span>
                }

                {fuelType.Including12MonthOnlyFlag === "N"
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        Your electric vendors should only be reporting electric billing data for
                        a 12-month period.  If one or more of your vendors are reporting for data
                        for a period longer than 12 months this will cause your reported average
                        electric baseload expenditures to be too high. 
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="Including12MonthOnlyDesc"
                            id="Including12MonthOnlyDesc" style={{width:"100%"}}
                            value={fuelType.Including12MonthOnlyDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                  {fuelType.Including12MonthOnlyFlag === "U"
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        You need to know whether or not any of your electric vendors are
                        providing data for a period greater than 12 months in order to
                        fully assess the reliability of your data.  You may need to
                        review your vendor agreements or discuss with your IT department
                        to obtain this information. 
                        <br/><br/>
                        Please indicate your plans for obtaining this information in the box below.
                        <textarea  name="Including12MonthOnlyDesc"
                            id="Including12MonthOnlyDesc" style={{width:"100%"}}
                            value={fuelType.Including12MonthOnlyDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {/*OUTLIERS*/}
            <li>
                Do your electric vendors check outliers in the data they report to you
                to ensure that they did not make any errors?
                <br/>
                <label>
                    <input type="radio"
                        name="CheckOutliersFlag"
                        id="CheckOutliersFlag_true"
                        value="Y"
                        checked={fuelType.CheckOutliersFlag === "Y"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="CheckOutliersFlag"
                        id="CheckOutliersFlag_false"
                        value="N"
                        checked={fuelType.CheckOutliersFlag === "N"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="CheckOutliersFlag"
                        id="CheckOutliersFlag_dk"
                        value="U"
                        checked={fuelType.CheckOutliersFlag === "U"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Don't Know</span>
                </label>
                <br/ >

                {fuelType.CheckOutliersFlag === "Y"
                  && <span>
                        <strong>No action needed.</strong>
                        Your electric vendors should be checking the data
                        they report to you to ensure they have not made any errors.  
                      </span>
                }
                {fuelType.CheckOutliersFlag === "N"
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        Your electric vendors should be checking the data they report
                        to you to ensure they have not made any errors.  If
                        your vendors are not checking for outliers and errors,
                        just a few abnormally large expenditure amounts could
                        cause your reported average electric expenditures to be too high.
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="CheckOutliersDesc"
                            id="CheckOutliersDesc" style={{width:"100%"}}
                            value={fuelType.CheckOutliersDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                {fuelType.CheckOutliersFlag === "U"
                  &&
                    <span>
                        <strong>Requires followup.</strong>&nbsp;
                        You need to know whether your electric vendors are checking their data  
                        for errors and outliers in order to complete a full assessment
                        of your data reliability. You may need to review your vendor
                        agreements or discuss with your IT department to obtain this information.
                       <br/><br/>
                        Please indicate your plans for obtaining this information in the box below.
                        <textarea  name="CheckOutliersDesc"
                            id="CheckOutliersDesc" style={{width:"100%"}}
                            value={fuelType.CheckOutliersDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {/*ONLYAMTBILLED*/}  
            <li>
                Do your electric vendors indicate they are only including the new amounts that households are billed each month,
                and not the total amount owed (including any arrearages or overdue charges) in the expenditure amounts they report to you?
                <br/>
                <label>
                    <input type="radio"
                        name="IncludeOnlyAmountBilledFlag"
                        id="IncludeOnlyAmountBilledFlag_true"
                        value="Y"
                        checked={fuelType.IncludeOnlyAmountBilledFlag === "Y"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludeOnlyAmountBilledFlag"
                        id="IncludeOnlyAmountBilledFlag_false"
                        value="N"
                        checked={fuelType.IncludeOnlyAmountBilledFlag === "N"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="IncludeOnlyAmountBilledFlag"
                        id="IncludeOnlyAmountBilledFlag_dk"
                        value="U"
                        checked={fuelType.IncludeOnlyAmountBilledFlag === "U"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Don't Know</span>
                </label>
                <br/ >
                {fuelType.IncludeOnlyAmountBilledFlag === "Y"
                  && <span>
                      <strong>No action needed.</strong>
                      Your electric vendors should only be including the new monthly billing
                      amount assessed to the client each month. They should not be including
                      arrearages or other fees that build up on the clients account over time.   
                    </span>}
                {fuelType.IncludeOnlyAmountBilledFlag === "N"
                  &&<span><strong>Requires followup.</strong>&nbsp;
                        Your electric vendors should only be including the new monthly billing
                        amount assessed to the client each month. If your vendors are including
                        arrearages or other charges that build that carry over from one month to
                        another then this will cause your reported average electric bill to be too high. 
                        <br/><br/>
                        Please indicate your plans to address this issue in the box below
                        <textarea  name="IncludeOnlyAmountBilledDesc"
                            id="IncludeOnlyAmountBilledDesc" style={{width:"100%"}}
                            value={fuelType.IncludeOnlyAmountBilledDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                  {fuelType.IncludeOnlyAmountBilledFlag === "U"
                  &&<span><strong>Requires followup.</strong>&nbsp;
                        You need to know whether your vendors are only including the new billing
                        amount for customers each month rather than including arrearages or other
                        fees that carry over from previous months. You may need to review your
                        vendor agreements or discuss with your IT department to obtain this information.
                        <br/><br/>
                        Please indicate your plans for obtaining this information in the box below.
                        <textarea  name="IncludeOnlyAmountBilledDesc"
                            id="IncludeOnlyAmountBilledDesc" style={{width:"100%"}}
                            value={fuelType.IncludeOnlyAmountBilledDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>

            {/* SignificantSupplierCharges */}
            <li>
                Do your electric vendors indicate that a large portion of your assisted households are
                being assessed a third-party supplier charge?
                <br/>
                <label>
                    <input type="radio"
                        name="SignificantSupplierChargesFlag"
                        id="SignificantSupplierChargesFlag_true"
                        value="Y"
                        checked={fuelType.SignificantSupplierChargesFlag === "Y"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Yes</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="SignificantSupplierChargesFlag"
                        id="SignificantSupplierChargesFlag_false"
                        value="N"
                        checked={fuelType.SignificantSupplierChargesFlag === "N"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>No</span>
                </label>
                &nbsp;&nbsp;
                <label>
                    <input type="radio"
                        name="SignificantSupplierChargesFlag"
                        id="SignificantSupplierChargesFlag_dk"
                        value="U"
                        checked={fuelType.SignificantSupplierChargesFlag === "U"}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}
                    />
                    <span>Don't Know</span>
                </label>
                <br/ >
                {fuelType.SignificantSupplierChargesFlag === "Y"
                  && <span>
                      <strong>No action needed.</strong> 
                      Your electric vendors should be including third-party supplier charges
                      in the amounts they report to you. So, if they are already doing this
                      you don’t need to make a change. However, third-party supplier charges
                      may not be reflected in the ACS data that were used to provide an
                      estimate of the annual electric bill for households in your state,
                      so this may be why your  reported average electric bill is higher
                      than expected.
                    </span>}
                {fuelType.SignificantSupplierChargesFlag === "N"
                  &&<span><strong>No action needed.</strong>&nbsp;
                        Third-party supplier charges may not be reflected in the ACS data 
                        that were used to provide an estimate of the annual electric bill. 
                        However, since you indicated that you do not have a significant 
                        number of households being assessed a third-party supplier
                        charge this is not likely to be the cause of your issue. 
                        <br/><br/>
                    </span>}
                  {fuelType.SignificantSupplierChargesFlag === "U"
                  &&<span><strong>Requires followup.</strong>&nbsp;
                        You need to know whether a significant portion of your households 
                        are being assessed third-party supplier charges in order to
                        complete a full assessment of your data. You may need to
                        review your vendor agreements or discuss with your IT
                        department to obtain this information.
                        <br/><br/>
                        Please indicate your plans for obtaining this information in the box below.
                        <textarea  name="SignificantSupplierChargesDesc"
                            id="SignificantSupplierChargesDesc" style={{width:"100%"}}
                            value={fuelType.SignificantSupplierChargesDesc}
                            onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                    </span>}
                <br/><br/>
            </li>


            {(state.assessment1ShowCatchallQuestionOver(fuelType) === true && showDontKnowNote === true)
            &&
                <div>
                    It appears that your potential data reliability issue cannot be
                    explained by the most common reasons we have found
                    for why states' estimates differ from the ACS.
                    Please contact APPRISE to discuss other potential
                    explanations for this discrepancy. If you have any
                    ideas about what might be causing the discrepancy
                    please document it in the response box below.                        
                    <textarea  name="OtherReasonDesc"
                        id="OtherReasonDesc" style={{width:"100%"}}
                        value={fuelType.OtherReasonDesc}
                        onChange={(changeEvent) => state.assessment1FieldChangeHandler(changeEvent, fuelType)}></textarea>
                </div>
            }
        </ol>
    </div>
);

export default Assessment1QuestionsOverReporting;
